import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useCompanyInfo } from '../../hooks/useCompanyInfo';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_event-maestro-95/artifacts/hu1fdxw0_Logo%20fe%CC%82te%20-%20show%20e%CC%81ve%CC%80nement%20-2.png';

export default function Footer() {
  const company = useCompanyInfo();
  return (
    <footer className="footer-ink">
      <div className="container-ose py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src={LOGO_URL}
                alt="Show Événement"
                className="h-14 w-auto object-contain"
              loading="lazy" />
            </Link>
            <p className="text-sm mb-5" style={{ color: 'rgba(251,247,241,0.55)', lineHeight: '1.7' }}>
              Votre spécialiste en location et animation événementielle — Lot, Aveyron, Cantal.
            </p>
            <div className="flex flex-col gap-2.5">
              <div className="flex items-center gap-2 text-sm" style={{ color: 'rgba(251,247,241,0.5)' }}>
                <MapPin size={14} style={{ color: 'var(--teal, #5DBCBF)' }} />
                {company.adresse_encaissement}
              </div>
              <div className="flex items-center gap-2 text-sm" style={{ color: 'rgba(251,247,241,0.5)' }}>
                <Phone size={14} style={{ color: 'var(--teal, #5DBCBF)' }} />
                <a href="tel:0756876665" style={{ color: 'inherit', textDecoration: 'none' }}>07 56 87 66 65</a>
              </div>
              <div className="flex items-center gap-2 text-sm" style={{ color: 'rgba(251,247,241,0.5)' }}>
                <Mail size={14} style={{ color: 'var(--teal, #5DBCBF)' }} />
                <a href="mailto:showevenementiel@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>showevenementiel@gmail.com</a>
              </div>
            </div>
          </div>

          {/* Prestations */}
          <div>
            <h4 className="font-semibold text-sm mb-4" style={{ color: 'var(--teal, #5DBCBF)' }}>Prestations</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { href: '/anniversaire-enfant-lot', label: 'Anniversaires enfant' },
                { href: '/mariage-lot', label: 'Mariages' },
                { href: '/animations-entreprise-lot', label: 'Entreprises & CE' },
                { href: '/jeux-animations', label: 'Jeux & animations' },
                { href: '/animations-gourmandes', label: 'Animations gourmandes' },
              ].map(l => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-sm transition-colors"
                    style={{ color: 'rgba(251,247,241,0.5)' }}
                    onMouseEnter={e => e.target.style.color = 'var(--teal, #5DBCBF)'}
                    onMouseLeave={e => e.target.style.color = 'rgba(251,247,241,0.5)'}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Liens */}
          <div>
            <h4 className="font-semibold text-sm mb-4" style={{ color: 'var(--teal, #5DBCBF)' }}>Liens utiles</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { href: '/creer-evenement', label: 'Créer mon événement' },
                { href: '/catalogue', label: 'Catalogue complet' },
                { href: '/boutique', label: 'Boutique' },
                { href: '/blog', label: 'Blog & conseils' },
                { href: '/devenir-partenaire', label: 'Devenez partenaire' },
                { href: '/contact', label: 'Contact' },
              ].map(l => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-sm transition-colors"
                    style={{ color: 'rgba(251,247,241,0.5)' }}
                    onMouseEnter={e => e.target.style.color = 'var(--teal, #5DBCBF)'}
                    onMouseLeave={e => e.target.style.color = 'rgba(251,247,241,0.5)'}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-semibold text-sm mb-4" style={{ color: 'var(--teal, #5DBCBF)' }}>Créer votre événement</h4>
            <p className="text-sm mb-4" style={{ color: 'rgba(251,247,241,0.5)', lineHeight: '1.6' }}>
              Devis gratuit en 2 minutes avec notre configurateur intelligent.
            </p>
            <Link
              to="/creer-evenement"
              className="btn-teal inline-block px-5 py-2.5 text-sm font-semibold rounded-xl mb-3"
            >
              Commencer maintenant
            </Link>
            <div>
              <a
                href="https://share.google/hZSHglw36RKeQgqnp"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs"
                style={{ color: 'rgba(251,247,241,0.45)', textDecoration: 'none' }}
              >
                ★★★★★ 4,6 — Laisser un avis Google
              </a>
            </div>
          </div>
        </div>

        <div className="divider-teal my-8" />

        <div className="text-center">
          <p className="text-xs mb-2" style={{ color: 'rgba(251,247,241,0.25)' }}>
            Interventions dans un rayon de 1h30 autour de Figeac — Lot (46), Aveyron, Cantal, Corrèze
          </p>
          <p className="text-xs" style={{ color: 'rgba(251,247,241,0.3)' }}>
            © 2026 Show Événement — Conçu par{' '}
            <span style={{ color: 'rgba(93,188,191,0.7)' }}>OSEZ STUDIO</span>
            , Groupe Market &amp; Développement
          </p>
        </div>
      </div>
    </footer>
  );
}
